import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pallet-details-box',
  standalone: true,
  imports: [],
  templateUrl: './pallet-details-box.component.html',
  styleUrl: './pallet-details-box.component.scss'
})
export class PalletDetailsBoxComponent {
  @Input()
  palletDetails: any;
}
